import { get, indexBy } from 'lodash/fp'

import { IHash, IPaginationState, Selector } from '../types/common'
import { createSelector } from 'reselect'
import { IUser } from '../types/user'

export const usersSelector: Selector<IUser[]> = get('users.users')

export const usersDictSelector: Selector<IHash<IUser>> = createSelector(
  usersSelector,
  (users) => indexBy('id', users),
)

export const usersPaginationStateSelector: Selector<IPaginationState> = get(
  'users.paginationState',
)

export const usersTotalSelector: Selector<number> = get('users.total')
